import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    anio_: 0,
    tipo: 3,
    mes_ano: 0,
    post: 0,
    anio_actual: 0,
    articulo_actual: 0,
    articulo_actual_titulo: '',
    vista_listado: false,
    vista_detalle: false,

    //variable idUsuario planeacion
    idUsuario: 0,

    modoDark_var: false
  },
  mutations: {
    modoDark(state){
      // console.log('asdada');
      state.modoDark_var = !(state.modoDark_var);
      // console.log('state.modoDark_var:', state.modoDark_var);
    },

/**
    LLENA VARIABLE IDUSUARIO DE PLANEACION PARA NO GUARDARLA EN LA COOKIE 😣
 */
    getIdUsuario(state, n){
      state.idUsuario = n;
      // console.log('store vuex: '+state.idUsuario);
    },


/*
    LLENAN LAS VARIABLES GLOBALES Q SON USADAS DESDE FILTROS.VUE Y SALAPRENSA.VUE😁
*/
    clasificacion(state, n){
      state.tipo = n;
    },
    anio(state, valor){
      state.anio_ = valor;
    },
    mes_anio(state, mes_ano){
      state.mes_ano = mes_ano;
    },


    articulo(state, valor){
      state.post = valor;
    },

    add_anio(state, valor){
      state.anio_actual = valor;
    },

    add_articulo(state, obj){
      state.articulo_actual = obj.id;
      state.articulo_actual_titulo = obj.titulo;
    },


    // FUNCIONES QUE ALTERNAN VISTA_LISTADO Y VISTA_DETALLE
    inicializar_v_listado(state){
      state.vista_listado = true;
      state.vista_detalle = false;
    },
    inicializar_v_detalle(state){
      state.vista_detalle = true;
      state.vista_listado = false;
    },




  },
  actions: {
  },
  modules: {
  }
})
